import React from 'react';
import {
  type ReferenceRecord,
  defaultFields,
  fieldsForItem,
} from './pillFields';
import classNames from 'classnames';
import { RECORD_ICONS } from 'javascripts/record_icons';
import styles from '../../../Reference.module.css';
import renderIf from 'render-if';
import { type AhaReferenceElement } from '@aha-app/aha-editor-v2';

type ReferenceAhaPillFieldsProps = {
  element: AhaReferenceElement;
  record: ReferenceRecord | null;
};

const ReferenceAhaPillFields: React.FC<ReferenceAhaPillFieldsProps> = ({
  element,
  record,
}) => {
  const {
    reference_class: itemClass,
    reference_num,
    reference_name,
    reference_visibleFields = defaultFields(itemClass),
  } = element;
  const fieldOptions = fieldsForItem(itemClass);

  if (record && fieldOptions) {
    const renderedFields = fieldOptions
      .filter(field => reference_visibleFields.includes(field.key))
      // Find fields that actually have content
      .map(field => ({ field, content: field.render(record, itemClass) }))
      .filter(({ content }) => Boolean(content))
      .map(({ field, content }, index, filteredOptions) => {
        const fieldBefore = filteredOptions[index - 1]?.field;
        const neverShowSeparator =
          field.separator === false || fieldBefore?.separator === false;
        const sometimesShowSeparator =
          field.separator === true || fieldBefore?.separator === true;
        const showSeparator = !neverShowSeparator && sometimesShowSeparator;

        return (
          <span key={field.key}>
            {renderIf(index > 0)(
              <span className={styles.separator}>
                {showSeparator ? ' | ' : ''}
              </span>
            )}
            {content}
          </span>
        );
      });

    return <>{renderedFields}</>;
  } else {
    return (
      <>
        <i
          className={classNames(
            RECORD_ICONS[itemClass],
            styles.icon,
            'aha-reference-icon'
          )}
        />
        &nbsp;
        {reference_num || reference_name}
      </>
    );
  }
};

export default ReferenceAhaPillFields;
